import { motion } from 'framer-motion';
import styled from 'styled-components';
import { theme } from '../../styles/theme';
import { mq } from '../../styles/mq';

export const SideMenuContainer = styled(motion.div)`
  display: none;

  ${mq.large} {
    display: block;
  }

  position: fixed;
  top: 14rem;
  left: 4.5rem;
  width: 30rem;
  max-width: 30rem;
  transition: right 0.5s;

  ${mq.large} {
    left: auto;
    right: calc((100% - 908px) / 2 + 908px - 15rem);
  }
  ${mq.xlarge} {
    width: 40rem;
    max-width: 40rem;
    right: calc((100% - 908px) / 2 + 908px - 20rem);
  }
`;
export const SideMenuChapter = styled(motion.div)<{ $isActive: boolean }>`
  font-size: 2.1rem;
  line-height: 2.5rem;
  margin-bottom: 2.5rem;
  padding-left: 3rem;
  color: ${theme.colors.text};
  font-weight: ${(props) => (props.$isActive ? 800 : 400)};
  cursor: pointer;
  ${mq.xlarge} {
    font-size: 2.4rem;
    line-height: 3rem;
    padding-left: 4rem;
  }

  span {
    position: absolute;
    transform: translateY(-1px);
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    margin-right: 1rem;
    font-size: 1.5rem;
    font-weight: 800;
    width: 2rem;
    height: 2rem;
    margin-top: 0.3rem;
    color: ${(props) =>
      props.$isActive ? theme.colors.text : theme.colors.background};
    background: ${(props) =>
      props.$isActive ? theme.colors.orange : theme.colors.text};

    ${mq.smallOnly} {
      width: 1.5rem;
      height: 1.5rem;
    }
    ${mq.xlarge} {
      font-size: 1.8rem;
      width: 2.4rem;
      height: 2.4rem;
    }
  }
`;
